<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
      <div class="modal-content">
        <font-awesome-icon class="window-close-icon" :icon="['fas', 'window-close']" @click="close" />
        <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Task Assessment</h3>
        <div class="container-fluid">
          <div class="table-responsive">
            <table class="assessment-table">
              <thead>
                <tr>
                  <th style="min-width: 120px;">License No</th>
                  <th style="min-width: 200px;">Name</th>
                  <th v-for="num in assessmentColumns" :key="num" style="min-width: 125px;">
                    {{ `Assessment ${num}` }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="trainee">
                  <!-- <tr v-for="(trainee, index) in trainees" :key="trainee.user_id"
                  :class="{ 'missing-task': isTraineeMissingTask(trainee.user_id) }"> -->
                  <td>{{ trainee.license_no }}</td>
                  <td>{{ trainee.first_name + ' ' + trainee.last_name }}</td>
                  <td v-for="num in assessmentColumns" :key="num" style="text-align:center;">
                    <button class="assess-button" :class="getAssessmentButtonClass(num)"
                      @click="openTaskAssessmentModal(num)">
                      {{ getAssessmentButtonLabel(num) }}
                    </button>
                    <!-- <button class="assess-button" :class="getAssessmentButtonClass(index, num)"
                      @click="openTaskAssessmentModal(index, num)" :disabled="isTraineeMissingTask(trainee.user_id)">
                      {{ getAssessmentButtonLabel(index, num) }}
                    </button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="button-container">
          <button class="ins-close-button" @click="close()">Close</button>
        </div>
        <task-assessment-modal v-if="showTaskAssessmentModal" :trainee="trainee" :tasks-count="MTCount"
          :completed-tasks="completedMTCount || 0" :assessmentEntryId="assessmentEntryId" :logbook-id="logbookId"
          :fetched-data="fetchedAssessmentEntryData" :attemptNo="attemptNo" :mergedTasks="this.mergedTasks"
          :trainee_assessments="this.trainee_assessments" :product="product" :assessment_tasks="assessment_tasks" :instructor="instructor"
          @close="closeTaskAssessmentModal"></task-assessment-modal>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import TaskAssessmentModal from '@/components/Instructor/TaskAssessmentModal.vue';


export default {
  name: 'ChooseAssessmentModal',
  components: {
    TaskAssessmentModal,
  },
  props: {
    logbookId: {
      type: Number,
      required: true,
    },
    trainee: {
      type: Object,
      required: true,
    },
    instructor: {
      type: Object,
      required: true,
    },
    mergedTasks: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      attemptData: [],
      logbookEntry: {},
      showTaskAssessmentModal: false,
      fetchedAssessmentEntryData: null,
      MTCount: '',
      completedMTCount: '',
      assessment_entries: [],
      assessment_tasks: [],
      trainee_assessments: [],
      attemptNo: '',
      product: {},
      assessmentEntryId: null,
    };
  },
  computed: {
    assessmentColumns() {
      return Array.from(
        { length: this.product?.assessment_count || 0 },
        (_, i) => i + 1
      );
    }
  },
  methods: {
    close() {
      this.$emit('close');
    },
    fetchAllAssessmentData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = parseInt(this.logbookId);

      axios.get(`/api/assessments/logbooks/${logbookId}`, { headers })
        .then(response => {
          const allAssessmentEntries = response.data;

          // Filter for current trainee only
          this.assessment_entries = allAssessmentEntries.filter(
            assessment => assessment.trainee_id === this.trainee.user_id
          );

          // One slot per column, matched by attempt_no as a column identifier only
          this.attemptData = this.assessmentColumns.map(colNum => {
            const entry = this.assessment_entries.find(
              a => a.attempt_no === colNum
            );

            return entry
              ? { result: entry.result, is_submitted: entry.is_submitted, is_selected: entry.is_selected }
              : { result: null, is_submitted: null, is_selected: null };
          });

          this.trainee_assessments = this.assessment_entries;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    fetchAssessmentTaskData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const projectId = parseInt(localStorage.getItem('project_id'));

      axios.get(`/api/assessment_tasks/projects/${projectId}`, { headers })
        .then(response => {
          this.assessment_tasks = response.data;
          console.log('assessmenttasks', this.assessment_tasks);
        })
        .catch(error => {
          console.error('There was an error fetching the product:', error);
        });
    },
    fetchProductData() {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const productId = localStorage.getItem('productId');

      axios.get(`/api/products/${productId}`, { headers })
        .then(response => {
          this.product = response.data;
        })
        .catch(error => {
          console.error('There was an error fetching the product:', error);
        });
    },
    openTaskAssessmentModal(colNum) {
      this.fetchedAssessmentEntryData = null;
      this.attemptNo = colNum;

      const matchingAssessment = this.assessment_entries.find(
        task => task.attempt_no === colNum
      );

      if (matchingAssessment) {
        this.assessmentEntryId = matchingAssessment.id;
        this.fetchedAssessmentEntryData = matchingAssessment;
      } else {
        this.assessmentEntryId = null;
        this.fetchedAssessmentEntryData = null;
      }

      this.showTaskAssessmentModal = true;
    },
    closeTaskAssessmentModal() {
      this.showTaskAssessmentModal = false;
      this.fetchAllAssessmentData();
    },
    getAssessmentButtonClass(colNum) {
      const data = this.getAttemptData(colNum);

      return {
        'pass-button': data?.result === 'pass' && data?.is_submitted === 4,
        'fail-button': data?.result === 'fail' && data?.is_submitted === 4,
        'in-progress-button': data?.is_submitted > 0 && data?.is_submitted <= 3
      };
    },
    getAssessmentButtonLabel(colNum) {
      const data = this.getAttemptData(colNum);

      if (!data || !data.is_submitted) return "Select";
      if (data.result === 'pass' && data.is_submitted === 4) return "Passed";
      if (data.result === 'fail' && data.is_submitted === 4) return "Failed";
      if (data.is_submitted === 2 || data.is_submitted === 3) return "Requires Grading";
      if (data.is_submitted === 1) return "In Progress";
      if (data.is_selected === 1) return "Selected";

      return "Select";
    },
    getAttemptData(colNum) {
      return this.attemptData[colNum - 1] || null;
    },
  },
  mounted() {
    this.fetchProductData();
    this.fetchAllAssessmentData();
    this.fetchAssessmentTaskData();
    console.log('mergedTasks', this.mergedTasks);
    console.log('inst1', this.instructor);
  },
};
</script>

<style scoped>
.modal-content {
  position: relative;
  max-height: 90vh;
  overflow-y: auto;
  padding: 15px;
  border: 1px solid #dddddd;
  border-radius: 3px;
}

.Evaluation-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1001;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 2px;
  max-height: 85vh;
  max-width: 90vw;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.container-fluid {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  /* smooth scroll on mobile */
  width: 100%;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px 8px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 20px;
  /* Adjust as needed */
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.assess-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
  width: 90px;
}

.assess-button:hover {
  background-color: rgb(180, 180, 180);
}

.assess-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

</style>